<!-- @veltra/icons generated sha256:ed21268d54077f36 gen:8 source:src/svg/normal/female.svg -->
<script setup lang="ts">
defineOptions({ name: 'Female' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8 1.678a3.5 3.5 0 0 0-.487 6.967v1.357h-1.49a.51.51 0 0 0-.51.504.51.51 0 0 0 .51.496h1.49v3.006c0 .276.228.494.504.494h.011a.48.48 0 0 0 .485-.494v-3.006h1.49a.51.51 0 0 0 .51-.504.51.51 0 0 0-.51-.496h-1.49V8.641A3.5 3.5 0 0 0 8 1.678m0 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
    />
  </svg>
</template>
